import cleanEscapedQuotes from '../../helpers/contentHelpers';

export default {
  name: 'PriceText',
  data() {
    return {
      className: 'app__product__price__formatted',
    };
  },
  computed: {
    priceHtml() {
      return this.formattedPrice ? cleanEscapedQuotes(this.formattedPrice) : '';
    },
  },
  props: {
    formattedPrice: {
      type: String,
      default: '',
    },
  },
};
